import React from "react";
import { chakra, Box, GridItem, Stack, useRadio, Center, Text, Grid, } from "@chakra-ui/react";
import { VscCircleSlash } from "react-icons/vsc";
import { FiCheckCircle } from "react-icons/fi";
import { animations } from "./Animations";
export const AnimationsRadio = ({ duration, animation, ...radioProps }) => {
    const { state, getInputProps, getCheckboxProps, getLabelProps, htmlProps } = useRadio(radioProps);
    const AnimationWrapper = animation.wrapper;
    return (React.createElement(GridItem, { "data-testid": "animation-radio-test-id", ...htmlProps, borderRadius: "2xl", sx: {
            aspectRatio: "1/1",
        } },
        React.createElement(chakra.label, { height: "100%", cursor: "pointer" },
            React.createElement(Stack, { height: "100%", ...getLabelProps() },
                React.createElement("input", { ...getInputProps({}), hidden: true }),
                React.createElement(Box, { ...getCheckboxProps(), flex: 1, borderWidth: state.isChecked ? 2 : 1, borderColor: state.isChecked ? "orange.500" : "gray.200", borderRadius: "2xl", position: "relative", overflow: "hidden" },
                    animation.type !== "none" ? (React.createElement(Center, { height: "100%", p: 2, sx: {
                            "> *": {
                                width: "72px",
                                height: "72px",
                            },
                        } },
                        React.createElement(AnimationWrapper, { delay: 0, duration: duration, preview: true },
                            React.createElement(Box, { width: "100%", height: "100%", bgColor: state.isChecked ? "orange.500" : "gray.200", borderRadius: "full" })))) : (React.createElement(Center, { height: "100%", sx: {
                            svg: {
                                color: state.isChecked ? "orange.500" : "gray.200",
                            },
                        } },
                        React.createElement(VscCircleSlash, { size: "72px" }))),
                    state.isChecked ? (React.createElement(Box, { position: "absolute", bottom: 4, right: 4, sx: {
                            svg: {
                                color: "orange.500",
                            },
                        } },
                        React.createElement(FiCheckCircle, null))) : (React.createElement(React.Fragment, null))),
                React.createElement(Text, null, animation.name)))));
};
export const AnimationsRadioGroup = ({ getRadioProps, getRootProps, duration, }) => {
    return (React.createElement(Grid, { ...getRootProps(), templateColumns: "repeat(3, 1fr)", gridGap: 4 }, animations.map((animation, index) => {
        return (React.createElement(AnimationsRadio, { "data-testid": "animation-radio-test-id", key: `animation-item-${index}`, animation: animation, duration: duration, ...getRadioProps({ value: animation.type }) }));
    })));
};
